import React, { Component } from "react";
import { Link } from "react-router-dom";

class Cabecalho extends Component {
  render() {
    return (
      <div id="myPage">
        <nav className="navbar navbar-default navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#myNavbar"
              >
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>              
            </div>
            <div className="collapse navbar-collapse" id="myNavbar">
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <Link to="/">SOBRE</Link>
                </li>
                <li>
                  <Link to="/servicos">SERVIÇOS</Link>
                </li>
                <li>
                  <Link to="/portifolio">PORTFOLIO</Link>
                </li>
                <li>
                  <Link to="/precos">PREÇOS</Link>
                </li>
                <li>
                  <Link to="/contato">CONTATO</Link>
                </li>
                <li>
                  <Link to="login">CONTA</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="jumbotron text-center">
          <img
            src={require("../images/logo.jpg")}
            alt="Paris"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    );
  }
}

/** 
 * 
 * <Link to="/">
                <a className="navbar-brand" href="#myPage">
                  <img
                    src={require("../images/logo.jpg")}
                    alt="Paris"
                    width="200"
                    height="30"
                  />
                </a>
              </Link>
 * <form>
                        <div className='input-group'>
                            <input type='email' className='form-control' size='50' placeholder='Email Address' required />
                            <div className='input-group-btn'>
                                <button type='button' className='btn btn-danger'>Subscribe</button>
                            </div>
                        </div>
                    </form>
*/

export default Cabecalho;
